// Add a response interceptor
import axios from 'axios';
//import Cookies from 'js-cookie';

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/api',
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);



api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If the error status is 401 and there is no originalRequest._retry flag,
    // it means the token has expired and we need to refresh it
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refreshToken');
            if(refreshToken){
              const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/Account/refreshToken`, { refreshToken });
              const { token } = response.data.accessToken;
              localStorage.setItem('accessToken', token);

              // Retry the original request with the new token
              originalRequest.headers.Authorization = `Bearer ${token}`;
            }else{
              axios.post(`${process.env.REACT_APP_BASE_URL}/api/OIDC/refreshToken`, {withCredentials: true,});
            }

        return axios(originalRequest);
      } catch (error) {
        // Handle refresh token error or redirect to login
      }
    }

    return Promise.reject(error);
  }
);

export default api